/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublisherListModel } from '../../models/publisher-list-model';

export interface PublisherPublisherListGet$Plain$Params {
}

export function publisherPublisherListGet$Plain(http: HttpClient, rootUrl: string, params?: PublisherPublisherListGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<PublisherListModel>>> {
  const rb = new RequestBuilder(rootUrl, publisherPublisherListGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<PublisherListModel>>;
    })
  );
}

publisherPublisherListGet$Plain.PATH = '/Publisher/PublisherList';
